export default {
  view: 'client.view_brand',
  add: 'client.add_brand',
  change: 'client.change_brand',
  delete: 'client.delete_brand',
  export: 'client.export_brand',
};
